import React from 'react'
import { Button, Grid, withStyles, IconButton } from '@material-ui/core'
import { Reply, Archive, Print } from '@material-ui/icons'
import styles from 'components/styles'
import language from 'utils/vast-languagepack'

export default withStyles(styles)(({ classes, icon }) => (
  <Grid container justify="space-evenly">
    {[
      { label: language.signupform.add.responses.exportButton, Icon: Reply, style: { transform: 'scaleX(-1)' } },
      { label: language.signupform.add.responses.downloadButton, Icon: Archive },
      { label: language.signupform.add.responses.printButton, Icon: Print },
    ].map(({ label, Icon, style }) => (
      <Grid key={`responseViewRightButton${label}`} item>
        {icon ? (
          <IconButton color="primary" disabled>
            <Icon />
          </IconButton>
        ) : (
          <Button variant="contained" disabled>
            <Icon className={classes.leftIcon} style={style} />
            {label}
          </Button>
        )}
      </Grid>
    ))}
  </Grid>
))
